import React from 'react';
import { Switch } from '@headlessui/react';
import Utilities from '@util/Utilities';
import { useFieldContext } from '@app/site/_form';

type SwitchFieldProps = {
	id?: string
	label?: string,
	isLarge?: boolean,
	onChange?: (value: boolean) => any,
	disabled?: boolean
}

export const SwitchField: React.FunctionComponent<SwitchFieldProps> = (
	{
		id,
		label,
		isLarge = false,
		disabled = false,
	},
) => {
	const field = useFieldContext<boolean>();

	return <Switch id={id} checked={field.state.value}
								 onChange={(value: boolean) => field.setValue(value)}
								 disabled={disabled}
								 className={Utilities.classNames(
									 field.state.value ? 'bg-blue-600' : 'bg-slate-200',
									 !isLarge && 'flex w-8 h-[18px] flex-none cursor-pointer rounded-full p-px ring-1 ring-inset ring-slate-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600',
									 isLarge && 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
								 )}
	>
		<span className="sr-only">{label}</span>
		<span
			aria-hidden="true"
			className={Utilities.classNames(
				field.state.value && !isLarge ? 'translate-x-3.5' : 'translate-x-0',
				field.state.value && isLarge ? 'translate-x-5' : 'translate-x-0',
				!isLarge && 'h-4 w-4 transform rounded-full bg-white shadow-sm ring-1 ring-slate-900/5 transition duration-200 ease-in-out',
				isLarge && 'inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
			)}
		/>
	</Switch>;
};